export * from '@primeuix/themes/material/carousel';
export { default } from '@primeuix/themes/material/carousel';
